
export class SubscriptionModulesModel {
  scheduling_module: boolean = false;
  tracking_module: boolean = false;
  dispatch_module: boolean = false;
  guard_portal_module: boolean = false;
  invoicer_module: boolean = false;
  payroll_module: boolean = false;
  sms_module: boolean = false;
  visitor_module: boolean = false;
  vehicle_patrol_module: boolean = false;
  parking_module: boolean = false;
  time_clock_module: boolean = false;

}
